import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProblemSection from "../components/ProblemSection";
import PositioningSection from "../components/PositioningSection";
import MainProduct from "../components/MainProduct";
import ServicesSection from "../components/ServicesSection";
import CaseStudies from "../components/CaseStudies";
import FAQ from "../components/FAQ";
import TransparencySection from "../components/TransparencySection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.slice(1);
    if (hash && location.pathname === "/") {
      const el = document.getElementById(hash);
      if (el) {
        const t = setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          150
        );
        return () => clearTimeout(t);
      }
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-[#fafafa]">
      <SEO />
      <Header />
      <Hero />
      <ProblemSection />
      <PositioningSection />
      <MainProduct />
      <ServicesSection />
      <CaseStudies />
      <FAQ />
      <TransparencySection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
